import type { FunctionalComponent, SVGAttributes } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

import { Policy } from '@/auth/Policy';
import { HEADER_EVENTS, type TrackEvent } from '@/analytics/events';

import CalendarIcon from '@/assets/icons/Calendar.svg';
import FolderAddIcon from '@/assets/icons/FolderAdd.svg';

export type HeaderActionId = 'create-booking' | 'create-experience';

export interface HeaderAction {
  id: HeaderActionId;
  label: string;
  policy: Policy;
  weight: number;
  /** Solo se muestra en el menú de mobile. */
  icon: FunctionalComponent<SVGAttributes>;
  variant?: 'filled' | 'outline';
  route?: RouteLocationRaw;
  analyticsEvent: TrackEvent;
  tourAnchorId?: string;
}

export const HEADER_ACTIONS: readonly HeaderAction[] = [
  {
    id: 'create-booking',
    label: 'Hacer reserva',
    policy: Policy.capability('booking:create'),
    weight: 10,
    icon: CalendarIcon,
    analyticsEvent: HEADER_EVENTS.createBooking,
    tourAnchorId: 'home_5',
  },
  {
    id: 'create-experience',
    label: 'Sumar experiencia',
    policy: Policy.capability('experience:create'),
    weight: 20,
    icon: FolderAddIcon,
    variant: 'outline',
    analyticsEvent: HEADER_EVENTS.createExperience,
    route: { name: 'new-activity-request' },
  },
];
